import gql from 'graphql-tag';

export const UPDATE_BATCH = gql`
mutation updateBatch($where:FindUniqueBranch, $data:UpdateBatchInput){
    updateBatch(
        where:$where
        data:$data
        ){
        _id
    }}
`;

export const GET_QR_CODE = gql`
mutation getQRCode($appMode:AppMode!, $gtin: String!, $generatePdf: Boolean, $batch: String){
    encodeBarcode(
        appMode: $appMode,
        gtin: $gtin,
        generatePdf: $generatePdf,
        batch: $batch
    ){
        pdfBase64,
        url
    }
}
`;

export const FORGOT_PASSWORD = gql`
    mutation forgotPassword($email: String){
        resetPassword(
            email: $email
        )
    }
`;

export const CHANGE_PASSWORD = gql`
    mutation resetPassword($email: String!, $password: String!, $passwordResetToken: String!){
        changePassword(
            email: $email
            password: $password
            passwordResetToken: $passwordResetToken
        )
    }
`;

export const CREATE_PRODUCT = gql`
    mutation createNewProduct($data : CreateUniqueProductInput){
        createProduct(
            data: $data
        ){
            gtin
        }
    }
`;

export const CREATE_PROVENANCE = gql `
    mutation createNewProvenance($where: UniqueProductInput!, $data: CreateProvenanceInput!) {
        createProvenance(
            data: $data
            where: $where
        )
    }
`;